import React from "react";
import {Spinner} from "@trp-innersource/react-communication";

const Loader = ({ isVisible }) => {
  if (isVisible) {
    return (
      <div>
        <Spinner />
      </div>
    );
  }
  return null;
};

export default Loader;
